import { inject, Injectable } from '@angular/core';
import { FiAccessRightHelperService } from '@fi-shared/fi-shared-services/fi-access-right-helper.service';
import { IAccessRightCoreFilter, ILightWeightObject } from '@fi-shared/models';
import { ObjectTypes } from '@fi-shared/types';

@Injectable()
export class FiChecklist2ScheduleSharingDisplayService {
    private fiAccessRightHelperService = inject(FiAccessRightHelperService);

    getSelectedAreasBusinessAreasNames(
        checklistScheduleAccessRightCoreFilter: IAccessRightCoreFilter,
        accessRightCoreFilter: IAccessRightCoreFilter,
    ): string {
        const result = [
            this.getSelectedSharingItemsNamesByObjectType(
                ObjectTypes.BusinessArea,
                checklistScheduleAccessRightCoreFilter,
                accessRightCoreFilter,
            ),
        ];

        if (checklistScheduleAccessRightCoreFilter.AreaIds?.length) {
            result.push(
                this.getSelectedSharingItemsNamesByObjectType(
                    ObjectTypes.Area,
                    checklistScheduleAccessRightCoreFilter,
                    accessRightCoreFilter,
                ),
            );
        }
        return result.join(', ');
    }

    getSelectedSharingItemsNamesByObjectType(
        objectType: ObjectTypes,
        checklistScheduleAccessRightCoreFilter: IAccessRightCoreFilter,
        accessRightCoreFilter: IAccessRightCoreFilter,
    ): string {
        const accessRightItems: ILightWeightObject[] = this.getAccessRightFilterCollectionByObjectType(
            objectType,
            accessRightCoreFilter,
        );
        const selectedItemsIds = this.getSelectedSharingItemsIdsByObjectType(
            objectType,
            checklistScheduleAccessRightCoreFilter,
        );
        const outOfScopeItems: ILightWeightObject[] = this.fiAccessRightHelperService.getOutOfScopeItems(
            accessRightItems,
            this.getAccessRightFilterCollectionByObjectType(objectType, checklistScheduleAccessRightCoreFilter),
        );
        return [...accessRightItems, ...outOfScopeItems]
            .filter((accessRightItem: ILightWeightObject) => selectedItemsIds.includes(accessRightItem.Id))
            .map((accessRightItem) => accessRightItem.Name)
            .join(', ');
    }

    private getAccessRightFilterCollectionByObjectType(
        objectType: ObjectTypes,
        accessRightCoreFilter: IAccessRightCoreFilter,
    ): ILightWeightObject[] {
        switch (objectType) {
            case ObjectTypes.Role:
                return accessRightCoreFilter.Roles;
            case ObjectTypes.BusinessUnit:
                return accessRightCoreFilter.BusinessUnits;
            case ObjectTypes.Area:
                return accessRightCoreFilter.Areas;
            case ObjectTypes.BusinessArea:
                return accessRightCoreFilter.BusinessAreas;
        }
    }

    private getSelectedSharingItemsIdsByObjectType(
        objectType: ObjectTypes,
        checklistScheduleAccessRightCoreFilter: IAccessRightCoreFilter,
    ): number[] {
        switch (objectType) {
            case ObjectTypes.Role:
                return checklistScheduleAccessRightCoreFilter.RoleIds;
            case ObjectTypes.BusinessUnit:
                return checklistScheduleAccessRightCoreFilter.BusinessUnitIds;
            case ObjectTypes.Area:
                return checklistScheduleAccessRightCoreFilter.AreaIds;
            case ObjectTypes.BusinessArea:
                return checklistScheduleAccessRightCoreFilter.BusinessAreaIds;
        }
    }
}
